import { render, staticRenderFns } from "./ProductHeading.vue?vue&type=template&id=f96457c6"
import script from "./ProductHeading.vue?vue&type=script&lang=ts"
export * from "./ProductHeading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports